<template>
  <div class="shop-rating" itemprop="aggregateRating" itemtype="https://schema.org/AggregateRating">
    <span class="shop-evaluation-count">{{ $t('Рейтинг') }} {{ shop.name }}: {{ shop.rating_count || 98 }} {{ $tc('оценка', shop.rating_count) }} </span>

    <div class="shop-stars-wrapper">
      <div class="shop-stars" @mouseover="selectStars" @mouseout="clearSelectedStars" @click="sendRating" ref="stars">
        <icon-base v-for="star in stars" :key="star.key"><component :is="star.icon"/></icon-base>
      </div>
      <span class="shop-evaluation">{{ shop.rating || 4.5 }}</span>
    </div>
    <div class="success-message" v-if="successMessage">{{ successMessage }}</div>
    <div class="error-message" v-if="errorMessage">{{ errorMessage }}</div>
    <meta itemprop="name" :content="shop.name">
    <meta itemprop="ratingValue" :content="shop.rating || 4.5">
    <meta itemprop="ratingCount" :content="shop.rating_count || 98">
    <meta itemprop="worstRating" content="0">
    <meta itemprop="bestRating" content="5">
  </div>
</template>

<script>
import axios from 'axios';
import utils from '../../mixins/utils.js';
import IconBase from '../IconBase.vue';
import IconStar from '../icons/IconStar.vue';
import IconStarOutline from '../icons/IconStarOutline.vue';
import IconStarHalf from '../icons/IconStarHalf';

const ratingCookie = 'rating_shops';

export default {
  name: 'shop-rating',

  mixins: [utils],

  components: {
    IconBase,
    IconStar,
    IconStarOutline,
    IconStarHalf
  },

  props: {
    shop: Object
  },

  data() {
    return {
      errorMessage: '',
      ratingShops: [],
      successMessage: '',
      selectedStars: 0
    };
  },

  computed: {
    stars() {
      const stars = [];
      const rating = this.selectedStars || this.shop.rating || 4.5;
      for (let i = 0; i < 5; i++) {
        if (Math.floor(rating) - i > 0) {
          stars.push({ key: i, icon: 'icon-star' });
        } else if ((Math.floor(rating) === i) && (rating % 1 >= 0.5)) {
          stars.push({ key: i, icon: 'icon-star-half' });
        } else {
          stars.push({ key: i, icon: 'icon-star-outline' });
        }
      }
      return stars;
    }
  },

  mounted() {
    this.ratingShops = JSON.parse(this.$cookies.get(ratingCookie)) || [];
  },

  methods: {
    clearMessages() {
      this.errorMessage = '';
      this.successMessage = '';
    },

    clearSelectedStars() {
      this.selectedStars = 0;
    },

    selectStars(e) {
      this.clearMessages();
      this.selectedStars = (e.pageX - this.$refs.stars.offsetLeft) / 24;
      this.selectedStars = Math.round(this.selectedStars * 100) / 100;
      if (this.selectedStars > 4.7) {
        this.selectedStars = 5;
      }
    },

    async sendRating() {
      this.clearMessages();
      if (this.sendRatingEnabled()) {
        try {
          const response = await axios.post(this.ratingUrl(), { slug: this.shop.slug, rating: this.selectedStars });
          this.ratingShops.push(this.shop.id);
          this.$cookies.set(ratingCookie, JSON.stringify(this.ratingShops));
          this.successMessage = 'Спасибо. Ваш голос принят!'
        } catch (err) {}
      } else {
        this.errorMessage = 'Вы уже голосовали!';
      }
    },

    sendRatingEnabled() {
      return this.ratingShops.indexOf(this.shop.id) === -1;
    },
  }
};
</script>

<style scoped>
.error-message, .success-message {
  padding: 10px 0;
}

.error-message {
  color: #f00;
}

.success-message {
  color: #2dbe00;
}

.shop-rating {
  display: flex;
  flex-direction: column;
}

.shop-evaluation-count {
  display: inline-block;
  margin: 15px 0 10px 0;
  font-size: 13px;
  color: #a9abb4;
}

.shop-stars-wrapper {
  display: flex;
  align-items: center;
}

.shop-stars {
  display: flex;
  margin-right: 10px;
  color: #3c91e6;
  cursor: pointer;
}

.shop-evaluation {
  font-size: 16px;
  color: #a9abb4;
}
</style>
